import { render } from "./ConfirmDeleteLink.vue?vue&type=template&id=56afd1ce&scoped=true"
import script from "./ConfirmDeleteLink.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteLink.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=56afd1ce&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56afd1ce"]])

export default __exports__